<div class="row d-flex justify-content-between">
    <div class="col-md-8 divSearch">
        <app-search [list]="AllUsers" [OriginalList]="OriginalUsers" [column]="'name'"
            (newItemEvent)="GetFilteredList($event)"></app-search>
    </div>
    <div class="col-md-3 divCreate">
        <a (click)="CreateNewUser(agentId)" class="btnCreate btn-icon-group">
            <i-tabler name="plus" class="icon-15 btn-icon"></i-tabler>
            {{ 'CreateNewUser' | translate}}
        </a>
    </div>
</div>

<div class="count" *ngIf="AllUsers.length!=0">{{'Results'| translate}}: {{AllUsers.length}}</div>
<div class="row">
    <div *ngIf="AllUsers?.length==0;then NoUsers else users"></div>

    <ng-template #NoUsers>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #users>
        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let user of AllUsers">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">{{ user.userName| subString:20
                        }}</mat-card-title>
                    <div class="d-flex divIcons" *ngIf="showEdit">
                        <i-tabler name="trash" class="icon-20 d-flex clickIcon" matTooltip="{{'Delete'|translate}}"
                            (click)="DeleteUser(user.id)"></i-tabler>
                        <i-tabler name="edit" class="icon-20 d-flex clickIcon" matTooltip="{{'Edit'|translate}}"
                            (click)="EditUser(user.id)"></i-tabler>
                        <i-tabler name="eye" class="icon-20 d-flex clickIcon" matTooltip="{{'View'|translate}}"
                            (click)="ViewUser(user.id)"></i-tabler>
                    </div>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content">
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table w-100">
                                <tr>
                                    <td>
                                        <i-tabler name="Phone" class="icon-15 d-flex icon"></i-tabler>
                                    </td>
                                    <td><span class="span-title">{{ 'Phone' | translate }}</span></td>
                                    <td><span> {{ user.phoneNumber }}</span></td>
                                </tr>
                                <tr>
                                    <td>
                                        <i-tabler name="mail" class="icon-15 d-flex icon"></i-tabler>
                                    </td>
                                    <td><span class="span-title">{{ 'Email' | translate }}</span></td>
                                    <td><span> {{ user.email }}</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>